import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { LunchBenefitListItemExtension } from './lunch-benefit-list-item.extension';
import { LunchBenefitMetadataExtension } from './lunch-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('lunch')
    .add(BenefitMetadataExtensionInterface, new LunchBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new LunchBenefitListItemExtension())
    .build(),
);
